import { render, staticRenderFns } from "./ChatAdmin.vue?vue&type=template&id=1ef159bd&"
import script from "./ChatAdmin.vue?vue&type=script&lang=js&"
export * from "./ChatAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports